import { ProfileItemVisibility } from '~/models'
import { SVGName } from '~/ui/components/SVG'

export function iconForProfileItemVisibility(visibility: ProfileItemVisibility): SVGName {
  switch (visibility) {
    case 'public': return 'eye'
    case 'connections': return 'handshake'
    case 'private': return 'eye-off'
  }
}